import ApiService from "@/services/ApiService";
import UtilityService from "@/services/UtilityService";

class UserService {
  lookupFiscalCode(fiscalCode) {
    return ApiService.get("/usr/v2/lookups/fiscal-code", {
      fiscalCode
    });
  }

  me() {
    return UtilityService.cachedService({
      service: "/usr/v2/users/me",
      storageKey: "cr_me",
      getNode: x => x.data
    });
  }

  requestDetails() {
    return UtilityService.cachedService({
      service: "/usr/v2/users/me/details",
      params: {
        fatcaGianos: true,
        contracts: true,
        documents: true,
        scans: true
      },
      storageKey: "cr_details",
      getNode: x => x.data
    });
  }

  getUserSubscriptions() {
    return ApiService.get(`usr/v2/users/me/subscriptions`);
  }

  getTutorship(minorId) {
    return ApiService.get(`usr/v2/users/me/tutorship/${minorId}`);
  }

  userParentType(minorId, type) {
    return ApiService.patch(`usr/v2/users/me/tutorship/${minorId}`, [
      { op: "replace", path: "/type", value: type }
    ]);
  }
}

export default new UserService();
